import './index.css';
import { jsx } from 'react/jsx-runtime';
import { useRef, useMemo, useCallback, useEffect } from 'react';
import { useVirtualizer } from '@tanstack/react-virtual';
import { Item } from './Item.js';
import { s as styles } from './tree-selector-item-B-I_mxX1.js';
import 'classnames';
import './ItemContent.js';
import '@hh.ru/magritte-common-keyboard';
import '@hh.ru/magritte-ui-icon/icon';
import './Action.js';
import '@hh.ru/magritte-ui-checkbox-radio';
import './TreeSelectorItemBase.js';
import '@hh.ru/magritte-ui-cell';
import '@hh.ru/magritte-ui-typography';

const getNewExpanded = (oldExpanded, newExpanded) => {
    if (oldExpanded.length >= newExpanded.length) {
        return [];
    }
    return newExpanded.filter((i) => !oldExpanded.includes(i));
};
const ItemsList = (props) => {
    const { collection, leavesOnly, checkSelectable, selected, expanded, disabled, onExpansion, indeterminate, onChange, isSearch, singleChoice, renderItemForDesktop, renderContentBefore, } = props;
    const prevExpanded = useRef(expanded);
    const expandedIds = useRef(expanded);
    const treeItems = useMemo(() => {
        const newItems = [];
        expandedIds.current = getNewExpanded(prevExpanded.current, expanded);
        collection.walk((item, currentParents) => {
            const parentId = currentParents.length ? currentParents[0].id : undefined;
            const isExpandedChild = currentParents.every((parent) => expanded.includes(parent.id));
            if (!parentId || isExpandedChild) {
                newItems.push({
                    ...item,
                    parentIds: currentParents.map((parent) => parent.id),
                });
            }
        });
        return newItems;
    }, [collection, expanded]);
    const marginCache = useRef({});
    const parentRef = useRef(null);
    const withPromoContent = !!renderContentBefore;
    const getKey = (index) => {
        const treeIndex = withPromoContent ? index - 1 : index;
        const treeItem = treeItems[treeIndex];
        if (withPromoContent && index === 0) {
            return 'promo';
        }
        return treeItem.parentIds[0] ? `${treeItem.parentIds[0]}${treeItem.id}` : `${treeItem.id}`;
    };
    const virtualizer = useVirtualizer({
        count: treeItems.length + (withPromoContent ? 1 : 0),
        getScrollElement: () => parentRef.current,
        estimateSize: () => 48,
        getItemKey: getKey,
    });
    const refCallback = useCallback((node) => {
        parentRef.current = node ? node.parentElement : null;
    }, []);
    const items = virtualizer.getVirtualItems();
    useEffect(() => {
        virtualizer.scrollToOffset(0);
    }, [collection, virtualizer]);
    useEffect(() => {
        prevExpanded.current = expanded;
    }, [expanded]);
    const onAnimationEnd = () => {
        expandedIds.current = [];
    };
    return (jsx("div", { ref: refCallback, className: styles.virtualizedList, style: {
            height: `${virtualizer.getTotalSize()}px`,
        }, children: jsx("div", { className: styles.virtualizedItem, style: {
                transform: `translateY(${items[0]?.start}px)`,
            }, children: items.map((virtualItem) => {
                if (withPromoContent && virtualItem.index === 0) {
                    return (jsx("div", { ref: virtualizer.measureElement, "data-index": virtualItem.index, children: renderContentBefore(isSearch) }, virtualItem.key));
                }
                const treeIndex = withPromoContent ? virtualItem.index - 1 : virtualItem.index;
                const treeItem = treeItems[treeIndex];
                const { parentIds, ...item } = treeItem;
                const parentId = parentIds[0];
                const wasExpanded = expandedIds.current.some((expandedId) => parentIds.includes(expandedId));
                return (jsx("div", { ref: virtualizer.measureElement, "data-index": virtualItem.index, onAnimationEnd: onAnimationEnd, className: wasExpanded ? styles.wasExpanded : undefined, children: jsx(Item, { collection: collection, checkSelectable: checkSelectable, isSelected: selected.includes(item.id), isExpanded: expanded.includes(item.id), isIndeterminate: indeterminate.includes(item.id), isDisabled: disabled.includes(item.id), parentId: parentId, item: item, leavesOnly: leavesOnly, singleChoice: singleChoice, onExpansion: onExpansion, onChange: onChange, isSearch: isSearch, renderItemForDesktop: renderItemForDesktop, cache: marginCache.current }) }, virtualItem.key));
            }) }) }));
};

export { ItemsList };
//# sourceMappingURL=ItemsList.js.map
